














import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import searchInput from "@/components/searchInput.vue";
import passwordModal from "@/views/usercenter/passwordModal.vue";
import util from "@/lib/util";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";

import myCollectKnow from "@/views/usercenter/myCollectKnow.vue";
import myCollectQA from "@/views/usercenter/myCollectQA.vue";

@Component({
    components: {
        searchInput,
        myCollectKnow,
        myCollectQA
    }
})
export default class myCollect extends basicPage {
    customActiveKey = '0'
    hasHeight: boolean = false;
    data: any = {};
    resourcesPath: string = '';
    form: any;

    mounted() {
        // this.loadData();
    }

    openPassword() {
        let passwordModal: any = this.$refs['passwordModal'];
        passwordModal.showModal();
    }

    handleTabClick(e) {
        this.customActiveKey = e;
    }
}
